export const config = {
    mapsURL: "https://maps.google.com/maps?q=Biuro%20Rachunkowe%20AKSIOM&t=&z=13&ie=UTF8&iwloc=&output=embed",
    linkedinURL: "https://www.linkedin.com/in/biuro-rachunkowe-aksiom-b203171b2/",
}